import { Color3 } from "../../Maths/math.color.js";
/**
 * Default settings for GreasedLine materials
 */
export class GreasedLineMaterialDefaults {
}
/**
 * Default line color for newly created lines
 */
GreasedLineMaterialDefaults.DEFAULT_COLOR = Color3.White();
/**
 * Default line width when sizeAttenuation is true
 */
GreasedLineMaterialDefaults.DEFAULT_WIDTH_ATTENUATED = 1;
/**
 * Defaule line width
 */
GreasedLineMaterialDefaults.DEFAULT_WIDTH = 0.1;
//# sourceMappingURL=greasedLineMaterialDefaults.js.map